<div class="table-tr">
  <div appTableRowContent class="flex justify-between items-center p-8">
    <div class="flex flex-row items-center endpoint-title p-8">
      <mat-icon svgIcon="open_in_new" class="icon-md mr-12 cursor-pointer" (click)="urlService.openUrlInNewTab(endpoint.url)"></mat-icon>
      <span class="fw-500 mat-subtitle-2 fs-14 mr-12">{{endpoint.name}}</span>
      <mat-icon *ngIf="showCopyUrl" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer" (click)="onCopyId(endpoint?.url)"></mat-icon>
    </div>
    <div class="w-3/5 pl-8">
      <div class="description mat-body-2" [matTooltip]="endpoint.description" 
      matTooltipPosition="above" matTooltipClass="tooltip-inner above fs-14">{{endpoint.description}}</div>
    </div>
  </div>
</div>